<!--合并订单-->
<template>
  <el-dialog
    title="合并订单"
    :visible.sync="dialogHebingVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >

    <div ref="print1" style="width: 640px;margin: 0 auto; ">

      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}</td>
          <td align="right">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right">仓&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>
            <!--<el-select v-model="form.cangkucode" placeholder="请选择" style="width: 135px;" size="mini">-->
            <!--<el-option-->
            <!--v-for="item in jxcstoreData"-->
            <!--:key="item.cangkucode"-->
            <!--:label="item.cangkuname"-->
            <!--:value="item.cangkucode">-->
            <!--</el-option>-->
            <!--</el-select>-->
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">门&nbsp;&nbsp;&nbsp;&nbsp;店：</td>
          <td width="140">{{controlData.customername}}</td>
          <td align="right" width="40">地&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.caddress}}</td>
          <td align="right" width="60">联系人：</td>
          <td width="120">{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">服务商：</td>
          <td>{{controlData.applybydname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>

        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td></td>
                <td style="text-align: center">订单号</td>
                <td style="text-align: center">下单时间</td>
              </tr>
              <tr v-for="item in tableData" style="cursor:pointer;">
                <td style="text-align: center">
                  <el-checkbox v-model="item.checked" @change="Change(item)"></el-checkbox>
                </td>
                <td style="text-align: center">{{item.erpserial}}</td>
                <td style="text-align: center">{{item.adddate}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)"></div>
          </td>
        </tr>
      </table>

    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogHebingVisible = false">取 消</el-button>
      <el-button type="primary" @click="delivergoods" class="qrbtn">保存</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {getPrice} from '@/api/set/goodsprice';
  import {printing, jxcstorelist, identicalstore, hebingOrder} from '@/api/set/csagreement';
  import {getParameterDetail} from '@/api/set/parameter';
  import {saveOutboundDataNew} from '@/api/set/warehouse';
  import {getRemark} from '@/plugin/ordercommon'
  import {saveData} from '@/api/set/handlelog';

  export default {
    name: 'CstagreementEditHeBing',
    data() {
      return {
        dialogHebingVisible: false,
        loading: true,
        parameterData: [],
        deliveryaddress: '',
        erpserial: '',
        erpserials: [],
        formLabelWidth: '120px',
        jxcstoreData: [],
        tableData: [],
        unitguid: "",
        unitguids: [],
        controlData: {},
        cangkucode: ''
      }

    },
    methods: {
      Change(item) {
        if (item.checked) {
          this.unitguids.push(item.unitguid)
          this.erpserials.push(item.erpserial)
        } else {
          for (let i = 0; i < this.unitguids.length; i++) {
            if (this.unitguids[i] == item.unitguid) {
              this.unitguids.splice(i, 1)
              this.erpserials.splice(i, 1)
              break
            }
          }
        }
      },
      formatTime() {
        var data = new Date();
        var year = data.getFullYear();
        var month = data.getMonth() + 1;
        var day = data.getDate();
        var hour = data.getHours();
        var minute = data.getMinutes();
        var second = data.getSeconds();
        return year + '-' + month + '-' + day + " " + hour + ":" + minute + ":" + second;
      },
      show() {
        this.unitguids = []
        this.dialogHebingVisible = true;
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      initData(row) {
        this.initForm()
        this.cangkucode = row.cangkucode
        this.erpserial = row.erpserial
        this.unitguid = row.unitguid
        printing({unitguid: row.unitguid, needunitguid: '1'}).then(response => {
          this.controlData = response.data.obj.detail;
          identicalstore({
            pcustomerserial: this.controlData.pcustomerserial,
            customerserial: this.controlData.customerserial,
            erpserial: row.erpserial,
            status: 200
          }).then(response => {
            this.tableData = response.data.obj;
            this.$set(this.tableData, "checked", false)
          });
        });


      },
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = '合并订单'
        handlelog.remark = JSON.stringify(this.erpserials) + '订单合并'
        saveData(handlelog).then(response => {
        })
      },
      delivergoods() {
        if (!this.unitguids.length) {
          this.$message({
            message: '请选择需要合并订单',
            type: 'message'
          })
          return
        }
        hebingOrder({
          unitguid: this.unitguid,
          erpserial: this.erpserial,
          unitguids: JSON.stringify(this.unitguids),
          erpserials: JSON.stringify(this.erpserials)
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.dialogHebingVisible = false;
            this.handlelog();
            //刷新列表
            this.$emit("bindGrid")
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        });
      },

      initForm() {
        this.itemtemp = {}
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.groupguid = ""
        this.tableData = []
        this.unitguid = ""
        this.erpserials = []
      }

    },
    mounted() {
      jxcstorelist().then(response => {
        this.jxcstoreData = response.data.obj
        if (this.jxcstoreData.length>0)
        this.cangkucode = this.jxcstoreData[0].cangkucode
      })
    },
    components: {}

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementEditHeBing.vue